import React from 'react';
import { Box } from '@fiverr-private/theme';
import { useIsClient } from '@fiverr-private/hooks';
import Categories from '../../../apps/logged_out_homepage/components/Categories';
import EntryWrapper from '../../../apps/logged_out_homepage/components/EntryWrapper';
import AppContextProvider from '../../../apps/logged_out_homepage/context/AppContextProvider';
import SubcategoryCarousel from '../../../apps/logged_out_homepage/components/SubcategoryCarousel';
import { getSubCategories } from '../../../apps/logged_out_homepage/components/SubcategoryCarousel/config';
import { shouldLoadPersonalizedSection } from '../../../apps/logged_out_homepage/components/PersonalizedSectionWrapper/shouldLoad';
import VideoHeroBannerWrapper from '../../../apps/logged_out_homepage/components/VideoHeroBannerWrapper';
import FiverrGuides from '../../../apps/logged_out_homepage/components/FiverrGuides';
import Signup from '../../../apps/logged_out_homepage/components/Signup';
import PersonalizedSectionWrapper from '../../../apps/logged_out_homepage/components/PersonalizedSectionWrapper';
import Freelancers from '../../../apps/logged_out_homepage/components/Freelancers';
import Video from '../../../apps/logged_out_homepage/components/Video';
import ProBanner from '../../../apps/logged_out_homepage/components/ProBannerSection';
import AiBanner from '../../../apps/logged_out_homepage/components/AiBannerSection';

interface LoggedOutHomepageClientProps {
    userWasLoggedIn?: boolean;
    withEnglishBAL?: boolean;
}

const LoggedOutHomepageClient = ({ userWasLoggedIn, withEnglishBAL }: LoggedOutHomepageClientProps) => {
    const isClient = useIsClient();

    const shouldLoad = isClient ? shouldLoadPersonalizedSection({ userWasLoggedIn }) : false;

    return (
        <EntryWrapper>
            <AppContextProvider withEnglishBAL={withEnglishBAL}>
                <Box paddingBottom={{ default: '10', md: '7' }}>
                    <VideoHeroBannerWrapper />
                </Box>
                <Categories />
                {shouldLoad && <PersonalizedSectionWrapper />}
                <SubcategoryCarousel subCategories={getSubCategories(withEnglishBAL)} />
                <Freelancers />
                <ProBanner />
                <AiBanner />
                <Video />
                <FiverrGuides />
                <Signup />
            </AppContextProvider>
        </EntryWrapper>
    );
};

export default LoggedOutHomepageClient;
